import baseReport from '../baseReportImpressao';
import _ from 'lodash';
import { exists } from 'fs';
import { nextTick } from 'q';
import formatNumber from '../../plugins/filters/formatNumber';
import formatDataBR from '@/plugins/filters/formatDataBR';

const montarAssinatura = (professores, filtros, tipoDeEnsino) => {
  return [
    {
      columns: [
        { width: '*', text: '' },
        {
          width: 'auto',
          alignment: 'right',
          layout: 'noBorders',
          table: {
            body: [
                ...professores.map(key => ([{
                  alignment: 'center',
                  fontSize: 8,
                  margin: [15, 35, 15, 0],
                  text: [
                    '_____________________________________________\n',
                    'Assinatura do Professor/Educador\n',
                    `${key.nmfuncion}\n`,
                    `${key.cdpessoal}-${key.cdmatric}`
                  ],
                }])),
            ],
          },
        },
        { width: '*', text: '' },
      ],
    },
    {
      fontSize: 9,
      italics: true,
      margin: [0, 20, 0, 0],
      text: [{ text: 'Obs.: ', bold: true }, (filtros.aaletivo >= 2020 && tipoDeEnsino === 'I') ? 'Este relatório apresenta todas as atividades cadastradas correspondentes a campos de experiência.' : 'Este relatório apresenta todas as atividades cadastradas correspondentes a disciplina.'],
    },
  ];
};

const registroNotasAnalitico = async ({ date, time, filtros, cdpravadi, data, professores, tipoDeEnsino, indicaanoletivoexcedeu = 'N', anoSubsequente }) => {
const headerFooter = await baseReport({ date, time, title: 'Diário de Classe', subTitle: 'Registro de Notas Analítico'}, 'landscape');

  let nameProfessores = professores.reduce((total, key) => `${total}${key.nmfuncion.trim()}, `, '');
  nameProfessores = nameProfessores.substring(0, nameProfessores.length - 2);

  const AnoSubsquente = indicaanoletivoexcedeu === 'S' ? [ { text: '   Ano subsequente:   ', bold: true }, anoSubsequente ] :  []

  const filtrosFormated = [
    {
      text: filtros.nmescola,
      bold: true,
      fontSize: 12,
      alignment: 'center',
      margin: [0, 5, 0, 5],
    },
    {
      fontSize: 9,
      text: [
        { text: 'Professor/Educador: ', bold: true },
        nameProfessores,
      ],
    },
    {
      fontSize: 9,
      columns: [
        {
          text: [
            { text: 'Ano letivo:  ', bold: true },
            filtros.aaletivo,
            ...AnoSubsquente
          ],
        },
        {
          alignment: 'right',
          text: [
            { text: 'Turma: ', bold: true },
            filtros.turma,
          ],
        },
      ],
    },
    {
      fontSize: 9,
      columns: [
        {
          text: [
            { text: (filtros.aaletivo >=2020 && tipoDeEnsino === 'I') ? 'Campos de Experiência:   ' : 'Disciplina:   ', bold: true },
            filtros.disciplina,
          ],
        },
        {
          alignment: 'right',
          text: [
            { text: 'Período: ', bold: true },
            filtros.periodo,
          ],
        },
      ],
    },
  ];

  function criarEspaco(tamanho, text=null, array=null){
    let teste = [];
    for (let index = 1; index < tamanho; index++) {
      if(array)
        teste.push({width:text});
      else
        teste.push({text});
    }
    return teste;
  }

  function resultado(media,somaEspec,valorPromocao){
    if(somaEspec != null){
      return (media >= valorPromocao)?'Aprovado':'Reprovado';
    }else{
      return  (media >= valorPromocao)?'Aprovado':'';
    }
  }

  function getOrdem(indicaatividade){
    switch (indicaatividade) {
      case 'N':
        return 1;
      case 'R':
        return 3;
      case 'E':
        return 5;
    }
  }

  //const atividades = await _.groupBy(_.sortBy(data.alunos[0].atividades,'cdpravadi'),'cdpravadi');

  const atividades = _.groupBy(_.sortBy(_.filter(data.alunos[0].atividades, function(n) {
    return n.indicaatividade != 'E';
  }),'cdpravadi'),'dspravadi');

  const atividadeOf = _.filter(data.alunos[0].atividades, {indicaatividade:'E'});

  const dataalunosOf = data.alunos;

  var alunoNotaPeriodo = [];

  var tabelas = [];

  for (let i in atividades) {
    let colunas = [];
    let titulo = [];
    let alunos = [];
    let widthsVar = [];

    colunas.push({
      text: 'Alunos',
      style: 'tableSubHeader',
      ordem: 0,
    });

    for (let j in atividades[i]) {
      colunas.push({
        text: atividades[i][j].siglaatividadeavaliativa,
        alignment: 'center',
        style: 'tableSubHeader',
        ordem: getOrdem(atividades[i][j].indicaatividade)
      });
    }
    colunas.push(
      {text:'Total', alignment:'center', style:'tableSubHeader', ordem: 2},
      {text:'Nota Final', alignment:'center', style:'tableSubHeader', ordem: 6}
    );

    colunas = _.sortBy(colunas,'ordem');

    for (let k in data.alunos) {
      if(isNaN(alunoNotaPeriodo[k])){
        alunoNotaPeriodo[k] = 0;
      }
      let notaFinal = 0;
      let totalN = 0;
      let totalR = 0;
      let totalE = 0;
      let invalido = '';
      let fillColor = '';

      if((data.alunos[k].invalido)){
        invalido = ` - ${data.alunos[k].invalido}`;
        fillColor = '#FFDAB9';
      }

      if (data.alunos[k].invalido === 'PDI') {
        alunos.push([{text:`${data.alunos[k].nmaluno}${invalido}\nDt Enturmação: ${formatDataBR(data.alunos[k].dtsitalun)} ${(data.alunos[k].dtafastam)? ` - ${formatDataBR(data.alunos[k].dtafastam)}` : ''}`, ordem:0,fillColor }])
       }
       else {
        alunos.push([{text:`${data.alunos[k].nmaluno}\nDt Enturmação: ${formatDataBR(data.alunos[k].dtsitalun)} ${invalido} ${(data.alunos[k].dtafastam)? ` - ${formatDataBR(data.alunos[k].dtafastam)}` : ''}`, ordem:0,fillColor }])
       }



      for (let l in data.alunos[k].atividades) {
        for (let j in atividades[i]) {
          if (data.alunos[k].atividades[l].identificadordistribuirnotas == atividades[i][j].identificadordistribuirnotas)
          {
            let valorNota = data.alunos[k].atividades[l].valornota;
            let valor = (valorNota == null)?0:valorNota;
             //= (atividades[i][j].indicaatividade =='R')?'#FF6347':((atividades[i][j].indicaatividade =='E')?'#90EE90':'#F0F8FF');
            switch (atividades[i][j].indicaatividade) {
              case 'N':
                totalN += parseFloat(valor);
                break;
              case 'R':
                totalR += parseFloat(valor);
                break;
              case 'E':
                totalE += parseFloat(valor);
                break;
            }
            //let valorFF = ? valor: '-';
            alunos[k].push({
                text: (valor)?formatNumber(parseFloat(valor)):'-',
                alignment: 'center',
                ordem: getOrdem(atividades[i][j].indicaatividade),
            });

          }
        }
      }

      notaFinal = (totalN > totalR)?totalN:totalR;
      alunos[k].push({text:formatNumber(totalN), alignment: 'center', ordem:2},{text:formatNumber(notaFinal), alignment: 'center', ordem: 6});
      alunoNotaPeriodo[k] += notaFinal;

      totalN = 0;
      notaFinal=0;
      alunos[k] = _.sortBy(alunos[k],'ordem');
    }

    widthsVar.push({width:'auto'}, ...criarEspaco(colunas.length, '*'));

    titulo.unshift({
      text: 'Período Avaliativo: '+ i,
      colSpan: colunas.length,
      alignment: 'center',
      style: 'tableHeader',
    }, ...criarEspaco(colunas.length));

    tabelas.push({
      margin: [0, 17, 0, 0],
      fontSize: 7,
      table: {
        widths: widthsVar,
        body: [
          titulo,
          colunas,
          ...alunos,
        ]
      },layout: {
				defaultBorder: true,
			}
    });
    if(cdpravadi == 'todos' || filtros.periodo == '3° TRIMESTRE')
      tabelas.push({text: '', pageBreak: 'before'});
  }


  if(filtros.periodo == 'Todos' || filtros.periodo == '3° TRIMESTRE'){
    let tituloOf = [];
    let colunasOf = [];
    let alunosOf = [];
    for (let i in atividadeOf) {
      colunasOf.push({
        text: atividadeOf[i].siglaatividadeavaliativa,
        style: 'tableSubHeader',
        alignment: 'center',
        ordem: 2,
      })
    }
    colunasOf.unshift({
      text: 'Alunos',
      style: 'tableSubHeader',
      ordem: 0,
    },{
      text: 'Total geral dos Períodos Avaliativos',
      style: 'tableSubHeader',
      alignment: 'center',
      ordem: 1,
    },
    {
      text: 'Resultado Final',
      style: 'tableSubHeader',
      alignment: 'center',
      ordem: 3,
    },
    {
      //{ text: (tipoDeEnsino === 'F')? 'Disciplina:   ' : 'Campos de Experiência:   ', bold: true },
     // text: 'Resultado Disciplina',
      text: (filtros.aaletivo >= 2020 && tipoDeEnsino === 'I')? 'Resultado Campos de Experiência' : 'Resultado Disciplina',
      style: 'tableSubHeader',
      alignment: 'center',
      ordem: 4,
    })
    colunasOf = _.sortBy(colunasOf,'ordem');

    tituloOf.push({
      text:'Período Avaliativo: Oportunidades Finais',
      alignment: 'center',
      style: 'tableHeader',
      colSpan: colunasOf.length,
    }, ...criarEspaco(colunasOf.length))

    let mediaFinal = null;

    for (let k in dataalunosOf){
      let somaEspec = null;
      dataalunosOf[k].atividades = _.filter(dataalunosOf[k].atividades, {indicaatividade:'E'});
      let invalido = '';
      let fillColor = '';
      if((dataalunosOf[k].invalido)){
        invalido = ` - ${dataalunosOf[k].invalido}`;
        fillColor = '#FFDAB9';
      }
     // console.log(dataalunosOf[k])
      alunosOf.push([{text:`${dataalunosOf[k].nmaluno}\nDt Enturmação: ${formatDataBR(data.alunos[k].dtsitalun)} ${invalido}${(data.alunos[k].dtafastam)? ` - Dt Afast: ${formatDataBR(data.alunos[k].dtafastam)}` : ''}`, ordem: 0, fillColor}]);
      for (let l in dataalunosOf[k].atividades){
        for (let j in atividadeOf) {
          if (dataalunosOf[k].atividades[l].identificadordistribuirnotas == atividadeOf[j].identificadordistribuirnotas)
          {
            let valor = dataalunosOf[k].atividades[l].valornota;

            alunosOf[k].push({
              text: (valor)?formatNumber(parseFloat(valor)):'-',
              alignment: 'center',
              ordem: 2,
            });

            if(valor != null)
              somaEspec += parseFloat(valor);
          }
        }
      }

      /*TRACA VALOR PELO TETO */
      //somaEspec = (somaEspec > data.valoresPromocaoAnual)? data.valoresPromocaoAnual: somaEspec;
      mediaFinal = (somaEspec != 0)? ((somaEspec > alunoNotaPeriodo[k])?somaEspec:alunoNotaPeriodo[k]) : alunoNotaPeriodo[k];

      alunosOf[k].push(
        {text:formatNumber(alunoNotaPeriodo[k]), alignment: 'center', ordem:1},
        {text:formatNumber(mediaFinal), alignment: 'center', ordem: 3},
        {text:resultado(mediaFinal,somaEspec,data.valoresPromocaoAnual), alignment: 'center', ordem: 4}
      );
      alunosOf[k] = _.sortBy(alunosOf[k],'ordem');
    }

    tabelas.push({
      margin: [0, 17, 0, 0],
      fontSize: 7,
      table: {
        widths: [{width:'auto'}, ...criarEspaco(colunasOf.length, '*')],
        body: [
          tituloOf,
          colunasOf,
          ...alunosOf,
        ]
      }
    });

  }

  const dataFormated = [tabelas];

  return {
    ...headerFooter,
    pageOrientation: 'landscape',

    content: [
      ...filtrosFormated,
      ...dataFormated,
      ...montarAssinatura(professores, filtros, tipoDeEnsino),
    ],
    styles: {
      tableHeader: {
        bold: true,
        fontSize: 10,
        color: 'black',
        fillColor: '#eeeeee'
      },
      tableSubHeader: {
        bold: true,
        fontSize: 7,
        color: 'black',
        fillColor: '#D3D3D3'
      },
      alunoInvalido:{
        fillColor: '#FFDAB9',
      }
    },
  };
};

export default registroNotasAnalitico;




